import { render, staticRenderFns } from "./EditarAviso.vue?vue&type=template&id=6846fef3&scoped=true"
import script from "./EditarAviso.vue?vue&type=script&lang=ts"
export * from "./EditarAviso.vue?vue&type=script&lang=ts"
import style0 from "./EditarAviso.vue?vue&type=style&index=0&id=6846fef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846fef3",
  null
  
)

export default component.exports